import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import { ReactComponent as Facebook } from '../../../../../resources/images/svg/facebook.svg';
import Instagram from '../../../../../resources/images/svg/instagram.svg';
import { ReactComponent as LinkedIn } from '../../../../../resources/images/svg/linkedin.svg';
import { ReactComponent as HotLineDesktop } from '../../../../../resources/images/svg/hotLineDesktop.svg';
import { ReactComponent as HotLineMobile } from '../../../../../resources/images/svg/hotLineMobile.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { getHomePageContent } from '../../../../../services/customer/pageContentServices';

function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/ka' || location.pathname === '/en' || location.pathname === '/am';
  const isSearchPage = location.pathname.includes('/search');

  const [footerLinks, setFooterLinks] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getHomePageContent();
        setFooterLinks(res?.data?.socials);
      } catch {
        setFooterLinks({});
      }
    };

    fetchData();
  }, []);

  const { trans, configInfo } = useTranslation();
  return (
    <footer className={`${isHomePage ? 'hidden lg:flex' : 'flex'} 2xs:flex-col 2xs:gap-10 lg:gap-0 lg:flex-row justify-between lg:items-center 2xs:w-screen lg:container px-5 pt-[30px] pb-[50px] lg:px-14 lg:py-0 lg:rounded-t-3xl bg-white lg:h-[177px] relative z-10
    ${isSearchPage && 'pb-[105px] lg:pb-[50px]'}
    `}
    >
      <div className="flex justify-between lg:hidden items-center">
        <div className="flex flex-col gap-4">
          <p className="m-0">
            {trans('follow')}
            :
          </p>
          <div className="flex gap-5">
            <a href={footerLinks?.facebook_url?.content} target="_blank" rel="noopener noreferrer">
              <Facebook />
            </a>
            <a href={footerLinks?.instagram_url?.content} target="_blank" rel="noopener noreferrer">
              <img src={Instagram} alt="instagram" />
            </a>
            <a href={footerLinks?.linkedin_url?.content} target="_blank" rel="noopener noreferrer">
              <LinkedIn />
            </a>
          </div>
        </div>
      </div>
      <div className="flex gap-9 items-center">
        {configInfo?.countryCode === 'GE' ? <GRLogo /> : (
          <img
            src="/ticketLogos/mobileLogoArm.png"
            alt="Armenia Railway Logo"
            width={90}
            height={42}
          />
        )}
        <div className="flex flex-col justify-center">
          <p className="m-0 text-xs lg:text-base">{trans('rights')}</p>
          <p className="m-0 text-xs lg:text-base">
            ©
            {trans(configInfo?.countryCode === 'GE' ? 'georgian-railway' : 'armenian-railway')}
          </p>
        </div>
      </div>
      {configInfo?.countryCode === 'GE' && (
      <>
        <div className="hidden lg:flex gap-4 items-center">
          <HotLineMobile className="h-[42px] mt-[19px]" />
          <HotLineDesktop className="h-14" />
        </div>
        <div className="hidden lg:flex flex-col gap-4">
          <p className="m-0">
            {trans('follow')}
            :
          </p>
          <div className="flex gap-5">
            <a href={footerLinks?.facebook_url?.content} target="_blank" rel="noopener noreferrer">
              <Facebook />
            </a>
            <a href={footerLinks?.instagram_url?.content} target="_blank" rel="noopener noreferrer">
              <img src={Instagram} alt="instagram" />
            </a>
            <a href={footerLinks?.linkedin_url?.content} target="_blank" rel="noopener noreferrer">
              <LinkedIn />
            </a>
          </div>
        </div>
      </>
      )}
    </footer>
  );
}

export default Footer;
